import { useEffect, useState } from "react";
import Button from "../Button";
import Password from "../Forms/Password";
import { warningsvg, eyesvg, closedeyesvg } from "../../assets/svg/svgimages";
import styles from "./EditProfileForm.module.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { changePassword } from "../../store/slices/profileSlice";

const PasswordForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    old_password: "",
    new_password: "",
  });
  
  const [errors, setErrors] = useState({});
  const [showNewPassword, setShowNewPassword] = useState(false);
  
  // Получаем состояние из Redux
  const { changePasswordError } = useSelector(state => state.profile.errors);
  const { changePasswordStatus } = useSelector(state => state.profile.status);

  const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    // Очищаем ошибки при изменении поля
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: "" }));
    }
  };

  const togglePasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };

  const goBack = () => {
    navigate("/profile/");
  };

  const validateForm = () => {
    const newErrors = {};

    // Валидация старого пароля
    if (!formData.old_password.trim()) {
      newErrors.old_password = "Old password is required";
    }

    // Валидация нового пароля
    if (!formData.new_password.trim()) {
      newErrors.new_password = "New password is required";
    } else if (!passwordRegex.test(formData.new_password)) {
      newErrors.new_password = 
        "Password must be at least 8 characters long and contain both letters and numbers";
    }

    return newErrors;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    // Сначала проводим клиентскую валидацию
    const validationErrors = validateForm();
    
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      console.log("Validation errors:", validationErrors);
      return;
    }

    // Очищаем ошибки перед отправкой
    setErrors({});

    try {
      await dispatch(changePassword({
        old_password: formData.old_password,
        new_password: formData.new_password
      })).unwrap();
      
      // Если успешно, очищаем форму
      setFormData({
        old_password: '',
        new_password: ''
      });
      
    } catch (error) {
      console.error("Password change error:", error);
      // Ошибки будут обработаны в useEffect, когда Redux состояние обновится
    }
  };

  // Слушаем изменения статуса для обработки ошибок после запроса
  useEffect(() => {
    if (changePasswordStatus === 'failed' && changePasswordError) {
      console.log("Server error detected:", changePasswordError);
      
      if (changePasswordError.old_password) {
        setErrors(prev => ({
          ...prev,
          old_password: Array.isArray(changePasswordError.old_password) 
            ? changePasswordError.old_password[0] 
            : changePasswordError.old_password
        }));
      } else if (changePasswordError.detail) {
        setErrors(prev => ({
          ...prev, 
          general: changePasswordError.detail
        }));
      } else if (changePasswordError.message) {
        if (changePasswordError.message.includes('400') || changePasswordError.message.includes('incorrect')) {
          setErrors(prev => ({
            ...prev,
            old_password: "Old password is incorrect"
          }));
        } else {
          setErrors(prev => ({
            ...prev,
            general: changePasswordError.message
          }));
        }
      }
    }
  }, [changePasswordStatus, changePasswordError]);

  return (
    <div className={styles.formcontainer}>
      <hr className={styles.hr} />
      <form onSubmit={handleSubmit}>
        <div className={`form-group ${styles.forms}`}>
          {/* Поле старого пароля */}
          <label htmlFor="old_password">
            <p>Old Password</p>
            <Password
              formData={formData}
              setFormData={setFormData}
              errors={errors}
              setErrors={setErrors}
            />
          </label>

          {/* Поле нового пароля */}
          <label htmlFor="new_password">
            <p>New Password</p>
            <div className="pass">
              <div
                className={`inputSvg ${errors.new_password ? "error" : ""}`}
                onClick={togglePasswordVisibility}
              >
                {showNewPassword ? closedeyesvg : eyesvg}
              </div>
              <input
                type={showNewPassword ? "text" : "password"}
                id="new_password"
                name="new_password"
                placeholder="Enter new password"
                value={formData.new_password}
                onChange={handleChange}
                className={errors.new_password ? "error" : ""}
              />
            </div>
            {errors.new_password && (
              <div className="error-message">
                {warningsvg} {errors.new_password}
              </div>
            )}
          </label>
        </div>

        <hr className={styles.hr} />
        
        {/* Кнопки и статус */}
        <div className={styles.btncontBig}>
          <div className={styles.btncont}>
            <Button id="button-editing"
              variant="outline-red"
              label="Close"
              labelPosition="left"
              iconType="crossbtn"
              onClick={goBack}
            />
            
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <Button id="button-editing"
                variant={changePasswordStatus === 'loading' ? "grey" : "blue"}
                label={changePasswordStatus === 'loading' ? "Saving..." : "Save changes"}
                labelPosition="left"
                iconType="checkMark"
                type="submit"
                disabled={changePasswordStatus === 'loading'}
              />
              
              
              {changePasswordStatus === 'failed' && errors.general && (
                <p style={{ color: "red", fontSize: "16px" }}>{errors.general}</p>
              )}
              
              {changePasswordStatus === 'failed' && changePasswordError?.detail && !errors.general && (
                <p style={{ color: "red", fontSize: "16px" }}>{changePasswordError.detail}</p>
              )}
            </div>
              {changePasswordStatus === 'succeeded' && (
                <p className="passwordik" style={{ color: "green", fontSize: "16px" }}>Password changed successfully!</p>
              )}
          </div>
        </div>
      </form>
    </div>
  );
};

export default PasswordForm;